// extracted by mini-css-extract-plugin
export default {"savedCardList":"MyCards_savedCardList__q-xcM","list":"MyCards_list__mtjHZ","numberType":"MyCards_numberType__vGbeS"};